
import { Badge } from "@/components/ui/badge";
import { Crown, User } from "lucide-react";

interface ContactStatusBadgeProps {
  relationshipStatus: 'Prospect' | 'Customer';
  customerSince?: string;
  size?: 'sm' | 'default';
}

export const ContactStatusBadge = ({ 
  relationshipStatus, 
  customerSince, 
  size = 'default' 
}: ContactStatusBadgeProps) => {
  const isCustomer = relationshipStatus === 'Customer';
  
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="flex flex-col gap-1">
      <Badge 
        variant={isCustomer ? 'default' : 'outline'} 
        className={`${size === 'sm' ? 'text-xs' : ''} w-fit`}
        style={{
          backgroundColor: isCustomer ? '#FB4F2B' : '#DFD4C9',
          color: isCustomer ? 'white' : 'black',
          borderColor: isCustomer ? '#FB4F2B' : '#DFD4C9'
        }}
      >
        {isCustomer ? (
          <><Crown className="h-3 w-3 mr-1" />Customer</>
        ) : (
          <><User className="h-3 w-3 mr-1" />Prospect</>
        )}
      </Badge>
      {isCustomer && customerSince && (
        <span className="text-xs text-muted-foreground">
          Since {formatDate(customerSince)}
        </span>
      )}
    </div>
  );
};
